import * as React from 'react'

import { useBloomreach } from '@grandvisionhq/bloomreach'
import { PromoteInstallments } from '@grandvisionhq/products'

import { promoteInstallmentsConfiguration } from '../../configuration'

type Props = Pick<
  React.ComponentPropsWithoutRef<typeof PromoteInstallments>,
  'priceType' | 'productType' | 'textAlign'
>

export const PromoteInstallmentsRestContainer = (props: Props) => {
  const { siteLogos } = useBloomreach()

  return (
    <PromoteInstallments
      siteLogos={siteLogos}
      numberOfInstallments={promoteInstallmentsConfiguration.numberOfInstallments}
      minimumPrice={promoteInstallmentsConfiguration.minimumPrice}
      priceType={props.priceType}
      productType={props.productType}
      textAlign={props.textAlign}
    />
  )
}
